module.exports = __webpack_public_path__ + "static/media/landing-1.4ffd1f12.png";